// Direct browser → S3 PUT to a presigned URL, with upload progress (fetch has
// no upload progress events, hence XHR).
// contentType must equal the type the URL was presigned with — S3 signs it.
export const putWithProgress = (
  url: string,
  file: File,
  onProgress: (pct: number) => void,
  contentType = file.type || 'application/octet-stream',
): Promise<void> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', contentType);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`S3 PUT ${xhr.status}`)));
    xhr.onerror = () => reject(new Error('network error'));
    xhr.send(file);
  });
